module.exports = __webpack_public_path__ + "88d6fe2e9f01143ea7e308af24c16a34.png";